import React, { useMemo } from 'react';

import { DocumentController } from '@/components/Shared/ui';
import { stringToCamelCase } from '@/services';
import { useAppSelector } from '@/store';
import type { TFileAttached } from '@/types/financing';

import { FILE_NAMES } from '../../constants';
import { GrnFactoryCheck } from '../../entities';
import useInstructionsText from '../../hooks/useInstructionsText';

const AltynBank: React.FC = () => {
  const { selectedBank, attachedFiles } = useAppSelector(
    (state) => state.financingStep
  );

  useInstructionsText();

  const files = useMemo(() => {
    if (!attachedFiles) return [];
    const files: TFileAttached[] = [];

    const computedAttachedFiles = attachedFiles.map((item) => ({
      ...item,
      type: stringToCamelCase(item.type)
    }));

    const grnAltyn =
      computedAttachedFiles.find(
        (item) =>
          item.type === 'grnAltyn' &&
          item.name.includes(selectedBank?.offeredUuid ?? '')
      ) || computedAttachedFiles.find((item) => item.type === 'grnAltyn');

    const otherDocuments = computedAttachedFiles.filter(
      (item) => item.type === 'spouseConsent' || item.type === 'techPassport'
    );

    if (grnAltyn) files.push(grnAltyn);
    if (otherDocuments.length) files.push(...otherDocuments);
    return files;
  }, [attachedFiles, selectedBank?.offeredUuid]);

  return (
    <div className="financing-step__form">
      {files
        ? files.map((file) => (
            <React.Fragment key={file.type}>
              <DocumentController
                fileLink={file.uuid}
                title={FILE_NAMES[file.type as keyof typeof FILE_NAMES]}
                downloadable
              />
              {file.type === 'grnAltyn' && (
                <GrnFactoryCheck
                  grnFileLink={file.link}
                  grnFileType={file.type}
                />
              )}
            </React.Fragment>
          ))
        : selectedBank?.status.code === 'financed' && (
            <p className="financing-step__no-documents">Нет документов</p>
          )}
    </div>
  );
};

export default AltynBank;
